import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { WebhookEndpoint } from 'src/features/webhook-endpoints/utils/types';

const RESOURCE = '/webhooks/webhook-endpoints/:endpointId/';

type QueryFnType = typeof queryFn;

interface DTO {
    endpointId: string;
}
const queryFn = ({ endpointId }: DTO): Promise<WebhookEndpoint> => {
    return axios.get(formatResourcePath(RESOURCE, { endpointId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetWebhookEndpoint, RESOURCE as WEBHOOK_ENDPOINT_RESOURCE };
